module.exports = __webpack_public_path__ + "static/media/dalaror3.d475cc54.png";